export const virtualView3dPointerEvents = {
    REQUEST_2D_SCENE: 'virtual-view::request2dScene',
};

export const virtualView2dPointerEvents = {
    LABEL_FOCUS: 'virtual-view::cnLabelFocus',
    LABEL_HOVER: 'virtual-view::cnLabelHover',
};
